export const tooltips = {
	// General Info tooltips
	sku:
		"SKU (Stock Keeping Unit) is a unique code to identify the product. If you don't fill it in, we'll generate one automatically.",
	preparationTime: "Enter the time it takes for the kitchen to prepare this product",
	hasAlcohol:
		"When activated, it will appear on the menu for customers that it contains alcohol",

	// Stock tooltips
	isStockable:
		"Stockable products are those that are stored in inventory until they are sold or used.",
	conversionRule:
		"Define how units of sale convert to units of stock. Ex: 1 bottle = 1 liter",

	// Fiscal Data tooltips
	ncm: "Common Mercosur Nomenclature",
	cest: "Tax Substitution Specifier Code",
	fiscalProfile: "Set of data that describes the tax situation of a person or company.",
	fiscalGroup:
		"Fiscal group is a code that classifies products according to their taxation.",

	// Pricing tooltips
	variablePrice: "Variable price: product price will be defined at POS",
};
